import { render, staticRenderFns } from "./AddMetadataModal.vue?vue&type=template&id=238f1f0a&scoped=true&"
import script from "./AddMetadataModal.vue?vue&type=script&lang=js&"
export * from "./AddMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMetadataModal.vue?vue&type=style&index=0&id=238f1f0a&prod&lang=scss&scoped=true&"
import style1 from "./AddMetadataModal.vue?vue&type=style&index=1&id=238f1f0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f1f0a",
  null
  
)

export default component.exports